const INFO_UPDATED = (state, info) => {
  state.info = info
}

export default {
  INFO_UPDATED,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/info/mutations.js